import type { RouteSummary } from '@viaja/contracts';
import { Button, EmptyState } from '@viaja/design-system';
import { useNavigate } from 'react-router-dom';
import { useRoutes } from '../../lib/queries';
import { MainScreen } from '../../ui/AppShell';
import { LoadError, Loading } from '../../ui/feedback';
import { RouteItem } from './RouteItem';

const GROUPS: { status: RouteSummary['status']; title: string }[] = [
  { status: 'active', title: 'De olho' },
  { status: 'paused', title: 'Pausadas' },
  { status: 'expired', title: 'Já passaram' },
];

export function RoutesPage() {
  const routes = useRoutes();
  const navigate = useNavigate();
  const create = () => navigate('/rotas/nova');

  return (
    <MainScreen>
      {routes.isPending ? (
        <Loading label="Buscando suas rotas…" />
      ) : routes.error ? (
        <LoadError message={routes.error.message} onRetry={() => routes.refetch()} />
      ) : routes.data.length === 0 ? (
        <EmptyState onAction={create} />
      ) : (
        <>
          <div className="app-head">
            <h1 className="display-title">Suas rotas</h1>
          </div>
          {GROUPS.map(({ status, title }) => {
            const items = routes.data.filter((r) => r.status === status);
            if (items.length === 0) return null;
            return (
              <section key={status} className="app-section" aria-labelledby={`grupo-${status}`}>
                <h2 id={`grupo-${status}`} className="eyebrow vc-eyebrow">
                  {title}
                </h2>
                <ul className="app-list">
                  {items.map((r) => (
                    <RouteItem key={r.id} route={r} />
                  ))}
                </ul>
              </section>
            );
          })}
          <div className="app-actionbar">
            <Button icon="mais" block onClick={create}>
              Monitorar uma rota
            </Button>
          </div>
        </>
      )}
    </MainScreen>
  );
}
